import { render } from "./Sponsor.vue?vue&type=template&id=70db5c48&scoped=true"
import script from "./Sponsor.vue?vue&type=script&lang=js"
export * from "./Sponsor.vue?vue&type=script&lang=js"

import "./Sponsor.vue?vue&type=style&index=0&id=70db5c48&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-70db5c48"

export default script